import { ReactComponent as SortAscendingIcon } from "@client/components/reusable/SvgIcons/library/sort_ascending.svg";
import { ReactComponent as SortDescendingIcon } from "@client/components/reusable/SvgIcons/library/sort_descending.svg";

import SvgIcon from "../reusable/SvgIcons";

type OrderTabSortProps = {
	sort: [number, number, number];
	setSort: (sort: [number, number, number]) => void;
	columnIndex: 0 | 1 | 2;
	pullingDataInProgress: boolean;
};

export function OrderTabSort({
	sort,
	setSort,
	columnIndex,
	pullingDataInProgress,
}: OrderTabSortProps) {
	const isAscending = sort[columnIndex] === 1;
	const icon = isAscending ? SortAscendingIcon : SortDescendingIcon;

	function onSortToggle() {
		if (pullingDataInProgress) {
			return;
		}

		const nextSort = [...sort] as [number, number, number];
		nextSort[columnIndex] = nextSort[columnIndex] === 1 ? 0 : 1;
		setSort(nextSort);
	}

	return (
		<div className="tab-selector-sort" onClick={onSortToggle}>
			<SvgIcon component={icon} />
		</div>
	);
}
